import script from "./SidebarConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarConfig.vue?vue&type=script&setup=true&lang=js"

import "./SidebarConfig.vue?vue&type=style&index=0&id=9a4f4510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a4f4510"]])

export default __exports__